import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const COMPANIES_ENDPOINTS = {
  V1: createEndpoints('v1', {
    COMPANIES: '/admin/companies/',
    COMPANY_DETAIL: (companyId: number) => `/admin/companies/${companyId}/`,
    COMPANY_TEAM_LIST: '/admin/company-team-list/',
    B2B_CREATE_COMPANY_USERS: '/admin/b2b-create-company-users/',
    COMPANY_TEAM_DETAIL: (id: number) => `/admin/company-team-details/${id}/`,
    B2B_BULK_CREATE_COMPANY_USERS: '/admin/b2b-bulk-create-company-users/',
    B2B_DOWNLOAD_COMPANY_USERS_TEMPLATE: '/admin/b2b-download-company-users-template/',
    COMPANY_ADMINS: '/admin/company-admins/',
    COMPANY_MEMBERS: '/admin/company-members/',
    COMPANY_GROUPS: '/admin/company-groups/',
    COMPANY_GROUP_DETAIL: (groupId: string) => `/admin/company-groups/${groupId}/`,
    COMPANY_GROUP_DETAIL_NO_SLASH: (groupId: string) => `/admin/company-groups/${groupId}`,
    COMPANY_PERMISSIONS: '/admin/company-permissions/',
    COMPANY_CONTRACTS: (companyId: number) => `/companies/${companyId}/contracts`,
  }),
} as const;
